/**
 * See required fields of the schema:
 * https://schema.org/ItemList
 *
 * Schema validator: https://developers.google.com/search/docs/advanced/structured-data
 */

interface IMicroData {
  '@context': 'https://schema.org';
  '@type': 'ItemList';
  name: string;
  description: string;
  numberOfItems: number;
  itemListElement: {
    '@type': 'ListItem';
    position: number;
    url: string;
  }[];
}

export const generateItemListMicrodata = (
  name: string,
  description: string,
  items: string[],
): IMicroData | null => {
  if (!name.trim() || !description.trim() || items.length === 0) return null;

  return {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: `${name} | Bridebook`,
    description,
    numberOfItems: items.length,
    itemListElement: items.map((url, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      url,
    })),
  };
};
